














import { Component, Vue, Inject } from 'vue-property-decorator'
import SideNav from '@/components/SideNav/sideNav.vue'

@Component({ components: { SideNav } })
export default class About extends Vue {
  loaded: boolean = false // 页面是否已经加载完成
  scrollTop () {
    document.documentElement.scrollTop = 0
    document.body.scrollTop = 0
    this.loaded = true
  }
  created () {
    this.loaded = true
  }
  mounted () {
    this.scrollTop()
    Lib.dispatchEvent(document, 'custom-render-trigger')
    // side-nav-item1、side-nav-item-active在sideNav.vue组件中声明
    let sideNav = document.querySelector('.side-nav-item1')
    let sideNavRoute = document.querySelector('#side-nav')// 选中AppHead.vue中'联系我们'
    if (sideNavRoute) {
      sideNavRoute.classList.remove('on')
      sideNavRoute.classList.add('on')
    }
    if (sideNav) {
      sideNav.classList.remove('side-nav-item-active')
      sideNav.classList.add('side-nav-item-active')
    }
  }
}
